<template>
  <v-list-tile :class="['list-tile', { pressed: pressed }, { 'open-presentation': marked }]" @click="goRoute(item.action)">
    <v-list-tile-action :class="{ 'list-icon': !drawer }">
      <v-tooltip right open-delay="50" close-delay="50">
        <template slot="activator">
          <v-icon color="#c4c9d0">{{ item.icon }}</v-icon>
          <template v-if="item.initials && drawer">
            {{ item.initials }}
          </template>
        </template>
        <span>{{ item.title }}</span>
      </v-tooltip>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
    </v-list-tile-content>

    <slot></slot>
  </v-list-tile>
</template>

<script>
const MARK_NAV_ELEMENT = [
  {
    action: 'presentaciones',
    route: 'presentacion'
  },
  {
    action: 'actualizaciones',
    route: 'actualizacion'
  },
  {
    action: 'actualizaciones',
    route: 'draft'
  }
]

export default {
  props: {
    item: Object,
    drawer: Boolean
  },

  data () {
    return {
      pressed: false,
      marked: false
    }
  },

  methods: {
    goRoute (route) {
      this.$router.push({ name: route })
    },
    shouldMark () {
      for (let item of MARK_NAV_ELEMENT) {
        if (this.item.action === item.action && this.$router.currentRoute.name === item.route) {
          return true
        }
      }
      return false
    }
  },

  created () {
    this.pressed = this.$router.currentRoute.name === this.item.action
    this.marked = this.shouldMark()
  },

  watch: {
    '$route.path' () {
      this.pressed = this.$router.currentRoute.name === this.item.action
      this.marked = this.shouldMark()
    }
  }
}
</script>

<style scoped>
.list-tile {
  padding: 0.2em 0 0.2em 0;
  color: #d8d8d7;
}
.pressed {
  background-color: #355487;
  border-right: 0.2em solid #0BBAD9;
}
.list-icon {
  padding: 0 0 0 1.1em;
}
.open-presentation {
  background-color: #355487;
}
</style>
